export const truncateText = (text: string, maxLength: number = 20) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

/**
 * 加密手机号
 * @param phone
 */
export const maskPhoneNumber = (phone: string | null | undefined): string => {
    if (!phone) {
        return '-';
    }

    // 去除非数字字符
    const cleanPhone = phone.replace(/\D/g, '');
    
    // 如果长度小于4位，直接返回原值（太短无法加密）
    if (cleanPhone.length < 4) {
        return phone;
    }
    
    // 如果是10位手机号
    if (cleanPhone.length === 10) {
        // 将第3到第6位（索引2-5）替换为 ****
        // 例如：1234567890 -> 12****7890
        const start = cleanPhone.slice(0, 2);  // 前2位
        const end = cleanPhone.slice(6);       // 第7位开始到结尾
        return `${start}****${end}`;
    }
    
    // 其他长度的号码：保留前2位和后2位，中间用****替换
    if (cleanPhone.length >= 6) {
        const start = cleanPhone.slice(0, 2);
        const end = cleanPhone.slice(-2);
        return `${start}****${end}`;
    }
    
    // 长度在4-5位之间：保留首尾各1位，中间用**替换
    const start = cleanPhone.slice(0, 1);
    const end = cleanPhone.slice(-1);
    return `${start}**${end}`;
};